// extracted by mini-css-extract-plugin
export var completionBody = "_mp-2";
export var completionCard = "_mp-0";
export var completionFooter = "_mp-3";
export var completionTitle = "_mp-1";